<!--
    课程商品-上课统计
    作用：展示校区中我的课程中上课情况
    功能：展示列表数据、查看详情
    组件：AppList、AppSearch
    版本号: 3.0
-->
<template>
  <div>
    <AppList
      ref="list"
      :list.sync="list"
      :columns="columnsLiveAll"
      :columns-check="columnsLive"
      :api-type="apiUrl"
      :api="apiUrl"
      :download-label="'导出搜索数据'"
      :download-loading="downloadLoading"
      title=""
      @downloadPage="downloadExcel"
      @checkedColumns="checkedColumns">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArrLive"
        @searchType="handlerSearch"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columnsLive"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :min-width="column.minWidth"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="200px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                class="opt-btn"
                size="small"
                @click="editSee(scope.row.id)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>

    <el-dialog
      v-if="dialogDetail.show"
      :visible.sync="dialogDetail.show"
      title="查看详情"
      width="1000px">
      <AppList
        :list.sync="dialogDetail.list"
        :api="dialogDetail.api"
        :exit-url="false"
        title="">
        <template slot-scope="props">
          <el-table :data="props.listData">
            <el-table-column
              v-for="column in dialogDetail.column"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :width="column.width"
              :formatter="column.formatter"
              align="center"
            />
          </el-table>
        </template>
      </AppList>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogDetail.show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ClassStatistics',
  data() {
    return {
      list: {},
      apiUrl: '',
      id: this.$route.query.id,
      downloadLoading: false,
      columnsLive: [],
      columnsLiveAll: [
        { index: 0,
          label: '校区名称',
          minWidth: '140px',
          disabled: true,
          formatter: (row) => {
            const info = row.clients_review_info ? row.clients_review_info : '--';
            const name = info ? info.name : '--';
            return name || '--';
          },
        },
        {
          index: 1,
          label: '上课时间',
          width: '180px',
          disabled: true,
          formatter: (row) => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time;
          },
        },
        {
          index: 2,
          label: '上课时长',
          formatter: (row) => {
            const time = this.$setting.setTime(row.all_liveroom_second);
            return `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
          },
        },
        { index: 3,
          label: '实际上课时长',
          formatter: (row) => {
            let diff = '00:00:00';
            if (row.living_duration) {
              const time = this.$setting.setTime(row.living_duration);
              diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
            }
            return diff;
          },
        },
        {
          index: 4,
          label: '上课状态',
          formatter: (row) => {
            const status = {
              1: '未开始',
              2: '上课中',
              3: '已结束',
              4: '缺课',
              5: '已取消',
            };
            return status[row.status];
          },
        },
        { index: 5, prop: 'teacher.name', label: '授课老师' },
        { index: 6, prop: 'teacher_mobile', label: '上课账号', width: '120px' },
        {
          index: 7,
          label: '课程名称',
          width: '130px',
          formatter: (row) => {
            const park = row.course_ware_packet_auth ? row.course_ware_packet_auth.packet : '';
            const name = park ? row.course_ware_packet_auth.packet.name : '--';
            return name || '--';
          } },
        { index: 8, prop: 'course_name', label: '课件名称', width: '110px' },
        {
          index: 9,
          label: '扣费形式',
          formatter: (row) => {
            const status = {
              0: '--',
              1: '金币',
              2: '会员',
              3: '商品',
              4: '课程包账号',
              5: '年服务',
              6: '体验期',
              7: '课程包次数',
            };
            return status[row.fee_type];
          },
          width: '100px',
        },
        { index: 10,
          prop: 'packet_number_consume',
          label: '耗课次数',
          // formatter: (row) => {
          //   const isNum = row.packet_auth_type === 2 ? 1 : 0;
          //   return isNum;
          // }
        },
        { index: 11, prop: 'liveroom_classes', label: '上课班级', width: '150px' },
        { index: 12,
          label: '班级学生数',
          formatter: row => row.student_count || 0 },
        { index: 13, prop: 'be_present', label: '出勤' },
        { index: 14, prop: 'present_logs', label: '有效参与学生数' },
        {
          index: 15,
          label: '上课端口',
          formatter: (row) => {
            const status = {
              0: '--',
              6: '教师端',
              14: '教学平台',
              15: 'AI播放器',
              16: 'SDK',
            };
            return status[row.access_client_id];
          },
          width: '100px',
        },
        { index: 16, prop: 'sdk_request', label: 'sdk调用次数', width: '110px' },
        { index: 17, prop: 'teacher_voice_count', label: '语音评测次数' },
        // {
        //   index: 4,
        //   label: '上课类型',
        //   formatter: (row) => {
        //     const status = {
        //       1: '班级直播间',
        //       2: '链接直播间',
        //       3: '线下课',
        //     };
        //     return status[row.type];
        //   },
        //   width: '100px',
        // },
        { index: 18,
          label: '账号有效期',
          width: '110px',
          formatter: (row) => {
            const time = row.course_ware_packet_auth ? row.course_ware_packet_auth.auth_expire_time : '--';
            return time || '--';
          } },
        // { index: 19,
        //   prop: 'living_duration',
        //   label: '直播实际时长',
        //   formatter: (row) => {
        //     let diff = '00:00:00';
        //     if (row.living_duration) {
        //       const time = this.$setting.setTime(row.living_duration);
        //       diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
        //     }
        //     return diff;
        //   },
        // },
      ],
      excelFiles: { // excel导出文件参数对应
        0: 'school_name', // 校区名称
        1: 'live_time', // 上课时间
        2: 'lesson_time_period', // 上课时长
        3: 'living_duration', // 实际上课时长
        4: 'live_status', // 上课状态
        5: 'teacher_name', // 授课老师
        6: 'teacher_mobile', // 上课账号
        7: 'packet_name', // 课程名称
        8: 'course_name', // 课件名称
        9: 'fee_type', // 扣费形式
        10: 'number_consume', // 耗课次数
        11: 'liveroom_classes', // 上课班级
        12: 'student_count', // 班级学生数
        13: 'be_present', // 出勤
        14: 'effective_student', // 有效参与学生数
        15: 'access_client', // 上课端口
        16: 'sdk_request', // sdk调用次数
        17: 'teacher_voice_count', // 语音评测次数
        18: 'account_period', // 账号有效期
      },
      dialogDetail: {
        show: false,
        list: {},
        column: [
          {
            prop: 'action',
            label: '操作动作',
            formatter: (row) => {
              const action = {
                1: '进入直播间',
                2: '退出直播间',
                3: '开始直播',
                4: '结束直播',
                5: '取消直播',
              };
              return action[row.action];
            },
          },
          { prop: 'created_at', label: '时间点' },
          {
            label: '直播时长（时分秒）',
            formatter: (row) => {
              const time = this.$setting.setTime(row.liveroom_second);
              return row.action === 4 ? `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}` : '00:00:00';
            },
          },
          { prop: 'act_student_count', label: '上课总人次' },
        ],
      },

      topData: {},

      searchList: {
        type: [
          { value: 1, name: '未开始' },
          { value: 2, name: '上课中' },
          { value: 3, name: '已结束' },
          { value: 4, name: '缺课' },
          { value: 5, name: '已取消' },
        ],
        access_client_id: [
          { value: 6, name: '教师端' },
          { value: 14, name: '教学平台' },
          { value: 15, name: 'AI播放器' },
          { value: 16, name: 'SDK' },
        ],
      },
    };
  },
  computed: {
    searchArrLive() {
      const column = [
        { prop: 'auth_packet_name', label: '课程名称' },
        { prop: 'name', label: '课件名称' },
        { prop: 'teacher_name', label: '授课老师' },
        { prop: 'teacher_mobile', label: '上课账号' },
        { prop: 'search_school_name', label: '校区名称' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          selectValue: this.searchList.type,
          componentType: 'AppSearchStatus',
          searchType: 'status',
          placeholder: '请选择上课状态',
        },
        {
          selectValue: this.searchList.access_client_id,
          componentType: 'AppSearchStatus',
          searchType: 'access_client_id',
          placeholder: '请选择上课端口',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
  },
  created() {
    this.apiUrl = '/api/liveroom?order[created_at]=desc&is_show_teacher=1';

    this.initColum([2, 6, 11, 12, 13, 14, 16, 17, 18]);
  },
  methods: {
    // classSearchType(data) {
    //   if (data['equal[access_client_id]'] === '16') {
    //     this.initColum([1, 5, 10, 11, 12, 13, 19]);
    //   } else {
    //     this.initColum([1, 5, 10, 11, 12, 13, 15, 16, 19]);
    //   }
    // },
    initColum(indexOff) {
      const initColumn = [];
      this.columnsLiveAll.forEach((item) => {
        if (indexOff.indexOf(item.index) === -1) {
          initColumn.push(item);
        }
      });
      this.columnsLive = initColumn;
    },
    timeFamate(num) {
      return num > 9 ? num : `0${num}`;
    },
    editSee(_id) {
      this.dialogDetail.api = `/api/liveroom/teacher/action/${_id}`;
      this.dialogDetail.show = true;
    },

    // 选择列表字段
    checkedColumns(val) {
      const data = [];
      val.forEach((item) => {
        this.columnsLiveAll.forEach((v) => {
          if (v.label === item) {
            data.push(v);
          }
        });
      });
      data.sort((a, b) => a.index - b.index);
      this.$nextTick(() => {
        this.columnsLive = data;
      });
    },
    // 导出数据
    downloadExcel() {
      this.source = axios.CancelToken.source();
      const filesArr = [];
      this.columnsLive.forEach((v) => {
        filesArr.push(this.excelFiles[v.index]);
      });
      const flies = filesArr.join();
      this.downloadLoading = true;
      const query = Object.keys(this.$route.query)
        .map(key => `${key}=${this.$route.query[key]}`)
        .join('&');
      this.$http.get(`/api/liveroom?order[created_at]=desc&is_show_teacher=1&action=export_excel&${query}&excel_fields=${flies}`, { responseType: 'blob', cancelToken: this.source.token }).then((res) => {
        this.downloadLoading = false;
        this.$setting.saveAs(res, '上课统计');
      }).catch((err) => {
        if (err.message.includes('timeout')) {
          this.$message.error('数据量过大，下载失败！请限制数据量，重新下载！');
        } else {
          this.$message.error(err.message);
        }
        this.downloadLoading = false;
      });
    },
    handlerSearch() {
      this.downloadLoading = false;
      this.source.cancel('下载失败！');
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/CourseGoods/ClassStatistics/index.vue